<template>
  <vs-popup title="Импорторованные платежи" :active.sync="active" class="employee-import-show-invoices-panel">
    <div class="employee-import-show-invoices-panel__button-export link-icon"
         @click.prevent.stop="exportInvoices" title="Экспорт в csv">
      <app-icon name="DownloadFile" size="22px" v-if="!isInvoicesExporting"/>
      <div class="block-loading" v-else/>
    </div>

    <vs-table :data="invoices" hoverFlat pagination max-items="20" class="employee-import-show-invoices-panel__table" no-data-text="Данных нет">
      <template slot="thead">
        <vs-th><span class="whitespace-no-wrap">Аккаунт</span></vs-th>
        <vs-th>Собственник</vs-th>
        <vs-th><span class="whitespace-no-wrap">Сумма платежа</span></vs-th>
        <vs-th><span class="whitespace-no-wrap">Месяц назначения</span></vs-th>
        <vs-th><span class="whitespace-no-wrap">Дата прохождения</span></vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="`${trIndex}`" v-for="(tr, trIndex) in data">
          <vs-td><span class="whitespace-no-wrap">{{tr.account_number}}</span></vs-td>
          <vs-td><div style="min-width: 180px; max-width: 220px">{{tr.apartment_owner}}</div></vs-td>
          <vs-td><span class="whitespace-no-wrap">{{tr.amount}}</span></vs-td>
          <vs-td><span class="whitespace-no-wrap">{{tr.monthyear}}</span></vs-td>
          <vs-td><span class="whitespace-no-wrap">{{tr.payment_passage_date}}</span></vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vs-popup>
</template>

<script>
  export default {
    name: "ShowInvoicesPopup",
    data(){
      return {
        active: false,
        isInvoicesExporting: false,
        invoices: [],
      }
    },
    methods: {
      open(invoices = []){
        this.invoices = invoices.map(invoice => {
          return {
            account_number: invoice.account_number,
            apartment_owner: invoice.apartment_owner,
            amount: this.$options.filters.numberWithSpaces(invoice.amount),
            monthyear: invoice.monthyear === null ? '' : this.$options.filters.moment(this.$parseDateFromString(invoice.monthyear), 'MMMM YYYY'),
            payment_passage_date: invoice.payment_passage_date === null ? '' : this.$options.filters.moment(this.$parseDateFromString(invoice.payment_passage_date)),
          }
        });
        this.active = true;
      },
      exportInvoices(){
        if (this.isInvoicesExporting) return false;
        this.isInvoicesExporting = true;
        let rows = Object.values(this.invoices).map(row => Object.values(row));
        let headerRow = ['Аккаунт', 'Сумма платежа', 'Месяц назначения', 'Дата прохождения'];
        rows = [headerRow].concat(rows);
        let csvContent = "data:text/csv;charset=utf-8,"
            + rows.map(e => e.join(",")).join("\n");
        let encodedUri = encodeURI(csvContent);
        let link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        let name = `Импортированные платежи.csv`;
        link.setAttribute("download", name);
        document.body.appendChild(link); // Required for FF

        link.click();

        this.$nextTick(() => {
          this.isInvoicesExporting = false;
          link.remove();
        })
      }
    }
  }
</script>

<style lang="scss">
  .employee-import-show-invoices-panel{

    &.con-vs-popup .vs-popup{
      width: auto;
    }

    &__button-export {
      display: block;
      align-items: center;
      justify-content: center;
      margin-left: auto;
      width: 22px;

      .block-loading {
        &::before {
          width: 16px;
          height: 16px;
        }
      }
    }

    &__table{
      .vs-table--tbody{
        border: none;
        background: #fff;
      }

      .vs-table--thead th{
        padding: 0!important;
        border-bottom: 1px solid rgba(0,0,0,.125);

        .vs-table-text{
          text-align: left;
          position: relative;
          vertical-align: bottom;
          padding: .75rem 10px;
          background: transparent;
          font-size: 12px;
        }
      }

      .vs-table{
        .vs-table--tr:nth-child(2n+1){
          background: #f5f8fa;
        }
      }

      .tr-values td{
        padding: .5rem 10px;
        font-size: 12px;
      }

      .vs-table--pagination{
        justify-content: center;
      }
    }
  }
</style>
